import styled from 'styled-components'

import { ENVIRONMENT_COLORS } from './EnvironmentAlert.consts'

export const ComponentStructure = styled.div<{
  isEnvironmentDanger?: boolean
}>`
  display: flex;
  align-items: center;
  color: #0c1014;
  text-align: center;
  padding: 16px;

  background-color: ${({ isEnvironmentDanger }) =>
    isEnvironmentDanger
      ? ENVIRONMENT_COLORS.DANGER
      : ENVIRONMENT_COLORS.WARNING};

  span {
    flex: 1;
  }
`

export const IconButton = styled.button`
  background: transparent;
  border: none;

  &:focus {
    box-shadow: unset;
  }

  &:hover {
    opacity: 0.8;
  }
`

export const AnimatedMessage = styled.span<{ isEnvironmentDanger?: boolean }>`
  animation: ${({ isEnvironmentDanger }) =>
    isEnvironmentDanger ? 'blinker 1s linear infinite' : 'none'};

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
`
